import script from "./TextContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./TextContainer.vue?vue&type=script&setup=true&lang=js"

import "./TextContainer.vue?vue&type=style&index=0&id=ecbe1112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecbe1112"]])

export default __exports__